import { FunctionComponent } from "react";

import { format } from "date-fns";

import { ListPerson } from "@/pages/Private/pages/List/schema/list";

import { Tooltip } from "@/components/Tooltip/Tooltip";
import { InfoCardPopover, InfoCardPopoverRow } from "@/components/InfoCardPopover";
import { ContactChannels, mapListPersonToChannelData } from "@/components/ContactChannels";

import { isDummyProspect } from "@/pages/Private/pages/List/utils/columns/dummyProspect";

import { NoContactYet } from "./NoContactYet";

export const LeadName: FunctionComponent<{
	row: ListPerson;
}> = ({ row }) => {
	// Placeholder ("SELECT" / "Person not found") rows have no real contact — show the Find-leads
	// call to action instead of the name.
	if (isDummyProspect(row)) {
		return <NoContactYet row={row} />;
	}

	return (
		<div className="flex flex-row gap-2 items-center w-full">
			<Tooltip
				className="flex-1 min-w-0"
				content={
					<div>
						{row.prospect?.snoozed ? (
							<div className="font-semibold text-sm px-2 pt-1">
								This prospect is snoozed until{" "}
								{format(new Date(row.prospect?.snoozedUntil || ""), "HH:mm dd.MM.yyyy")}
							</div>
						) : (
							""
						)}
						<InfoCardPopover
							kind="lead"
							rows={
								[
									{ label: "Name", value: row.prospect?.name },
									{
										label: "Job title",
										value: row.prospect?.jobTitleToSeniority?.jobTitle || row.prospect?.title,
									},
									{
										label: "Persona category",
										value: row.prospect?.scorePersonaCategoryResult?.result,
									},
									{ label: "Location", value: row.prospect?.country },
									{
										label: "Persona prio",
										value: row.prospect?.scorePersonaCategoryResult?.overallScore,
									},
								] satisfies InfoCardPopoverRow[]
							}
						/>
					</div>
				}
			>
				<div className="block w-full font-semibold text-sm text-ellipsis text-left overflow-hidden whitespace-nowrap rounded-[5px] px-[3px] py-[1px] -mx-[3px] -my-[1px] hover:bg-gray-50 transition-colors">
					{row.prospect?.name ?? "No name"}
				</div>
			</Tooltip>

			{row.prospect && (
				// -mr-1 swallows the last icon's built-in mr-1 so the cluster ends flush at the
				// row edge (and vertically aligns with the company row's icon cluster).
				<div className="flex flex-row items-center shrink-0 -mr-1">
					<ContactChannels data={mapListPersonToChannelData(row)} domain="list" />
				</div>
			)}
		</div>
	);
};
